import { useCallback, useState } from 'react';
import { Radio } from '@frontend/design-system';

type LocationRadioFieldProps = {
  isSelected: boolean;
  onSelected: () => void;
  trackingId?: string;
  testId?: string;
  id: string;
};

export const LocationRadioField = ({ isSelected, onSelected, trackingId, id, testId }: LocationRadioFieldProps) => {
  const [isActive, setIsActive] = useState(false);

  const onFocus = useCallback(() => {
    setIsActive(true);
  }, []);

  const onBlur = useCallback(() => {
    setIsActive(false);
  }, []);

  return (
    <Radio
      trackingId={trackingId}
      data-testid={testId}
      tabIndex={0}
      onBlur={onBlur}
      onFocus={onFocus}
      onChange={onSelected}
      active={isActive}
      id={id}
      checked={isSelected}
      name={''}
      disabled={false}
    />
  );
};
